// 緊急連絡先情報新規作成・編集画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor, isLoggedIn, userRole } from '../GlobalState';
import {
  addEmployeeEmergencyInfo,
  getEmployeeEmergencyInfoById
} from '../apicalls/employeeMaster';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { NotFoundPage } from './NotFoundPage';
import { EMPLOYEE_TYPE } from '../const/Const';

export const CreateEmployeeEmergencyInfo: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission, setUserPermission] = useRecoilState(userRole);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [loading, setLoading] = useState(true);
  const [emergencyContactName, setEmergencyContactName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [emergencyContactPhone, setEmergencyContactPhone] = useState('');
  const [emergencyPostalCode, setEmergencyPostalCode] = useState('');
  const [emergencyContactAddress, setEmergencyContactAddress] = useState('');
  const [firstPart, setFirstPart] = useState('');
  const [secondPart, setSecondPart] = useState('');

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        height: 60,
        maxHeight: 100,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();

  // 自社社員か社外パートナーか
  const employeeType: number = history.location.state.employeeType;
  // 編集か新規作成か
  const actionType: string = history.location.state.actionType;
  const isEditMode = actionType === 'edit';
  // 社員ID
  const employeeId: number = history.location.state.employeeId;

  //緊急連絡先情報の取得処理
  const getAllDetailsOfEmployeeMasterById = () => {
    getEmployeeEmergencyInfoById(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEmergencyContactName(data.data.emergency_contact_name);
            setRelationship(data.data.relationship);
            setEmergencyContactPhone(data.data.emergency_contact_phone);
            setEmergencyPostalCode(data.data.emergency_postal_code);
            setEmergencyContactAddress(data.data.emergency_contact_address);
            setLoading(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    getAllDetailsOfEmployeeMasterById();
  }, []);

  //保存前の入力値バリデーションと保存処理
  const saveEmployeeMasterDetails = () => {
    const trimmedEmergencyContactName = emergencyContactName?.trim() ?? '';
    const trimmedRelationship = relationship?.trim() ?? '';
    const trimmedEmergencyContactPhone = emergencyContactPhone?.trim() ?? '';
    const trimmedEmergencyContactAddress =
      emergencyContactAddress?.trim() ?? '';
    const trimmedEmergencyPostalCode = emergencyPostalCode?.trim() ?? '';

    if (trimmedEmergencyContactName === '') {
      setErrorMessage('緊急連絡先名を入力してください。');
      setOpen(true);
    } else if (trimmedEmergencyContactName.length > 20) {
      setErrorMessage('緊急連絡先名を20文字以内で入力してください。');
      setOpen(true);
    } else if (trimmedEmergencyContactPhone === '') {
      setErrorMessage('緊急連絡先 電話番号を入力してください。');
      setOpen(true);
    } else if (trimmedEmergencyContactPhone.length > 60) {
      setErrorMessage('緊急連絡先 電話番号を60文字以内で入力してください。');
      setOpen(true);
    } else if (firstPart && firstPart.length !== 3) {
      setErrorMessage('郵便番号の前半部分は3桁必要です。');
      setOpen(true);
    } else if (secondPart && secondPart.length !== 4) {
      setErrorMessage('郵便番号の後半部分は4桁必要です。');
      setOpen(true);
    } else if (trimmedEmergencyContactAddress === '') {
      setErrorMessage('緊急連絡先 住所を入力してください。');
      setOpen(true);
    } else if (trimmedEmergencyContactAddress.length > 225) {
      setErrorMessage('緊急連絡先 住所を225文字以内で入力してください。');
      setOpen(true);
    } else {
      addEmployeeEmergencyInfo(
        employeeId,
        trimmedEmergencyContactName,
        trimmedRelationship,
        trimmedEmergencyContactPhone,
        trimmedEmergencyPostalCode,
        trimmedEmergencyContactAddress
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    }
  };

  //郵便番号の分割処理
  useEffect(() => {
    if (emergencyPostalCode) {
      const [first, second] = emergencyPostalCode.split('-');
      setFirstPart(first || '');
      setSecondPart(second || '');
    }
  }, [emergencyPostalCode]);

  // 郵便番号の前半部分（3桁）の入力を処理
  const handleFirstPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 3);
    setFirstPart(value);
    setEmergencyPostalCode(`${value}-${secondPart}`);
  };
  // 郵便番号の後半部分（4桁）の入力を処理
  const handleSecondPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
    setSecondPart(value);
    setEmergencyPostalCode(`${firstPart}-${value}`);
  };

  // パンくずリスト表示パターン(編集)
  let patternName =
    employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
      ? 'employee_masters_edit'
      : 'outside_partnerem_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName =
      employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
        ? 'employee_masters_create'
        : 'outside_partnerem_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} />

      {(loading && isEditMode) || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight - 150
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      marginBottom: 20,
                      color: '#758283',
                      backgroundColor: '#F5F5F5'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // 業者詳細に戻る
                      if (history.location.state.partnerId) {
                        history.goBack();
                      }
                      // 社外パートナー一覧に戻る
                      history.push('/employee-masters', {
                        employeeType: employeeType
                      });
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              )}

              <div>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    {employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
                      ? '社員基本情報'
                      : '社外パートナー基本情報'}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: matches2 ? 'row' : 'column'
                  }}
                  className={classes.topList}
                >
                  <div
                    // 空アイテム
                    className='empty-list'
                    style={{ width: 15 }}
                  ></div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(`/employee-masters/${employeeId}/edit`, {
                          employeeId: employeeId,
                          actionType: 'edit',
                          employeeType: employeeType
                        });
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>基本情報</div>
                  </div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(
                          `/employee-health-info/${employeeId}/edit`,
                          {
                            employeeId: employeeId,
                            actionType: 'edit',
                            employeeType: employeeType
                          }
                        );
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>健康状態</div>
                  </div>
                  <div
                    className='border2'
                    style={{
                      backgroundColor: '#F5F5F5',
                      borderTopColor: '#0099CB',
                      borderBottom: 'none'
                    }}
                  >
                    <div
                      className={classes.topBoxText}
                      style={{ color: '#0099CB' }}
                    >
                      緊急連絡先情報
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      if (history.location.state?.employeeId) {
                        history.push(
                          `/employee-credentials-info/${employeeId}/edit`,
                          {
                            employeeId: employeeId,
                            actionType: 'edit',
                            employeeType: employeeType
                          }
                        );
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topBoxText}>資格情報</div>
                  </div>
                </div>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 5,
                      fontSize: 24
                    }}
                  >
                    {'緊急連絡先'}
                  </div>
                </div>
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          緊急連絡先名<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={emergencyContactName}
                            maxLength={20}
                            onChange={text => {
                              setEmergencyContactName(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>続柄</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={relationship}
                            onChange={text => {
                              setRelationship(text.target.value);
                            }}
                            className={classes.input}
                            maxLength={20}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          電話番号<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={emergencyContactPhone}
                            onChange={text => {
                              setEmergencyContactPhone(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>郵便番号</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <input
                            value={firstPart}
                            onChange={handleFirstPartChange}
                            className={classes.input}
                            style={{ width: '3em', marginRight: '0.5em' }}
                            maxLength={3}
                            inputMode='numeric'
                          />
                          <span>-</span>
                          <input
                            value={secondPart}
                            onChange={handleSecondPartChange}
                            className={classes.input}
                            style={{ width: '4em', marginLeft: '0.5em' }}
                            maxLength={4}
                            inputMode='numeric'
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          住所<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={emergencyContactAddress}
                            onChange={text => {
                              setEmergencyContactAddress(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
            <div style={{ height: 80 }} />
          </div>

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-around',
              padding: 20
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Button
                onClick={() => {
                  saveEmployeeMasterDetails();
                }}
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
              >
                保存
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
